<template>
  <div class="status-selector">
    <!-- Status display -->
    <div class="d-flex flex-row justify-content-center align-items-center">
      <p class="color-paye mb-0" v-if="status === 'paye'">
        <v-icon color="#1B5E20" class="mr-2">mdi-cash-check</v-icon><b>encaissé</b>
      </p>
      <p class="color-valide mb-0" v-if="status === 'valide'">
        <v-icon color="green accent-3" class="mr-2">mdi-check</v-icon><b>validé</b>
      </p>
      <p class="color-annuler mb-0" v-if="status === 'annuler'">
        <v-icon color="red" class="mr-2">mdi-cancel</v-icon><b>annulé</b>
      </p>
      <p class="mb-0" v-if="status === 'en Attend'">
        <v-icon color="gray" class="mr-2">mdi-timer-refresh-outline</v-icon><b>en attente</b>
      </p>
      <p class="color-valide mb-0" v-if="status === 'Accepter'">
        <v-icon color="green accent-3" class="mr-2">mdi-check</v-icon><b>validé</b>
      </p>
      <p class="mb-0" v-if="status === 'en validation'">
        <v-icon color="accent-3" class="mr-2">mdi-send-check</v-icon><b>en validation</b>
      </p>

      <v-icon
        size="22"
        class="dropdown-toggle"
        @click="toggleDropdown"
        left
        style="cursor: pointer"
      >
        mdi-chevron-down
      </v-icon>
    </div>
    
    <!-- Status selection dropdown -->
    <div
      class="text-center"
      v-show="isOpen"
      style="border: 0px solid white"
    >
      <v-btn
        @click="changeStatus('paye')"
        v-if="status !== 'paye'"
        class="mr-2"
        icon
        dark
        small
      >
        <v-icon color="#1B5E20">mdi-cash-check</v-icon>
      </v-btn>
      <v-btn
        @click="changeStatus('valide')"
        v-if="status !== 'valide' && status !== 'Accepter'"
        class="mr-2"
        icon
        small
        dark
      >
        <v-icon color="green accent-3">mdi-check</v-icon>
      </v-btn>
      <v-btn
        @click="changeStatus('en validation')"
        v-if="status !== 'en validation'"
        class="mr-2"
        icon
        small
        dark
      >
        <v-icon color="#137AE4">mdi-send-check</v-icon>
      </v-btn>
      <v-btn
        @click="changeStatus('annuler')"
        v-if="status !== 'annuler'"
        class="mr-2"
        icon
        small
        dark
      >
        <v-icon color="red">mdi-cancel</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusSelector',
  props: {
    status: {
      type: String,
      required: true
    },
    projectId: {
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    changeStatus(newStatus) {
      this.$emit('status-changed', {
        projectId: this.projectId,
        newStatus: newStatus
      });
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style scoped>
.color-paye {
  color: #1b5e20;
}
.color-validation {
  color: #137ae4;
}
.color-valide {
  color: #13e464;
}
.color-annuler {
  color: #ff5733;
}
</style>